import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Input from './input';
import FlagSelect from './flag-select';
import './form.scss';
import {useTranslation} from "react-i18next";

const countries = [
    { name: 'Англия', code: '+44', countryCode: 'GB' },
    { name: 'Германия', code: '+49', countryCode: 'DE' },
    { name: 'Франция', code: '+33', countryCode: 'FR' },
    { name: 'Польша', code: '+48', countryCode: 'PL' },
    { name: 'Россия', code: '+7', countryCode: 'RU' },
];

const CustomForm = () => {
    const { register, handleSubmit, reset } = useForm();
    const [selectedCountry, setSelectedCountry] = useState(countries[0]);
    const [phone, setPhone] = useState(selectedCountry.code);
    const { t } = useTranslation()

    const onSubmit = async (data) => {
        console.log(data);
        try {
            const formatedData = {
                name: data.name,
                phone: data.phone,
                email: data.email,
                amount: 'more 5000',
                issue_category: 'socarinvest',
                message: '0.0.0.0scscscs',
                country: data.country
            };

            await fetch('https://ancient.pr-finance.eu/lead/register-lead-from-brand', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formatedData)
            });

            alert(t('form.success'));
            reset();
        } catch (e) {
            console.log(e);
        }
    };

    const handleCountryChange = (country) => {
        setSelectedCountry(country);
        setPhone(country.code); // Обновляем код страны в инпуте
    };

    const handlePhoneChange = (e) => {
        const input = e.target.value;
        setPhone(input);

        // Проверяем, соответствует ли начало номера коду одной из стран
        const matchedCountry = countries.find((country) => input.startsWith(country.code));
        if (matchedCountry) {
            setSelectedCountry(matchedCountry); // Обновляем выбранную страну
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="form">
            <Input label={t('form.name')} name="name" register={register} />
            <Input label={t('form.email')} name="email" type="email" register={register} />

            <div className="phone-input">
                <input
                    {...register('phone')}
                    type="text"
                    placeholder="Phone"
                    value={phone}
                    onChange={handlePhoneChange}
                    className="input"
                />
                <FlagSelect onSelect={handleCountryChange} selectedCountry={selectedCountry} />
            </div>

            <button type="submit" className="button submit-button">{t('form.button')}</button>
        </form>
    );
};

export default CustomForm;
